import React from 'react';

import {IntlShape} from 'react-intl';
import BaselinePDFItem from './BaselinePDFItem';
import {BaselinePDFPhaseType} from './BaselinePDFTypes';
import {TextMain, TextSubHeader, ViewLine, ViewSection} from './layout/PDFLayout';

type BaselinePDFPhaseProps = {
	phase: BaselinePDFPhaseType;
	intl: IntlShape;
};

const BaselinePDFPhase = ({phase, intl: {formatMessage}}: BaselinePDFPhaseProps): JSX.Element => {
	return (
		<ViewSection>
			<TextSubHeader>{phase.name}</TextSubHeader>
			<ViewLine>
				<TextMain bold style={{width: '40%'}}>
					{formatMessage({id: 'baseline.pdf.item'})}
				</TextMain>
				<TextMain bold style={{textAlign: 'right', width: '20%'}}>
					{formatMessage({id: 'common.hours'})}
				</TextMain>
				<TextMain bold style={{textAlign: 'right', width: '20%'}}>
					{formatMessage({id: 'project_budget.hourly_rate'})}
				</TextMain>
				<TextMain bold style={{textAlign: 'right', width: '20%'}}>
					{formatMessage({id: 'baseline.pdf.total_price'})}
				</TextMain>
			</ViewLine>
			{phase.items.map(item => {
				return <BaselinePDFItem key={item.id} item={item} />;
			})}
			<ViewLine noBorder>
				<TextMain style={{width: '60%'}}></TextMain>
				<TextMain bold style={{textAlign: 'right', width: '20%'}}>
					{formatMessage({id: 'baseline.pdf.phase_total'})}
				</TextMain>
				<TextMain bold style={{textAlign: 'right', width: '20%'}}>
					{phase.total}
				</TextMain>
			</ViewLine>
		</ViewSection>
	);
};

export default BaselinePDFPhase;
